import React from 'react'
import { StyledContainer, StyledContent, Title } from './OnboardingNonRxEmailSubmission'

const NotAvailableOnState = (): JSX.Element => {
  return (
    <StyledContainer>
      <Title>Oh no! We&apos;re not available in your state.</Title>
      <StyledContent>
        We’re working hard to make Found available to everyone, but we’re not there yet.
        <br />
        <br />
        Let’s stay in touch so that we can let you know when we start to operate in your state.
        Please enter your email below:
      </StyledContent>
    </StyledContainer>
  )
}

export default NotAvailableOnState
